import { observer } from 'mobx-react-lite';

export default observer((props: { callback: Function }) => {
  const { callback } = props;
  return (
    <div className='back-button' onClick={() => callback()}></div>
  );
});